import css from 'styled-jsx/css';
import { colors } from '../../../theme/theme';

export const loadingStyles = css`
  .loading-wrapper {
    width: 100%;
    height: 149px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const noInviteCodesStyles = css`
  .message {
    font-size: 14px;
    font-weight: 500;
    color: #a3a3a3;
    text-align: center;
    padding: 24px 0;
  }
`;

export const inviteCodesStyles = css`
  .invite-codes-tab-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 220px);
    overflow: auto;
  }
  .invites-header {
    margin-bottom: 8px;
  }
  .invites-header :global(.list-item-wrapper:last-child) {
    border-bottom: none;
  }
  .invite-url-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-width: 0;
  }
  .invite-url {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: ${colors.black};
    min-width: 0;
    max-width: 100%;
    flex: 1;
  }
  .invite-codes-toolbar {
    display: flex;
    align-items: center;
    padding: 0 8px;
    margin-bottom: 8px;
    box-sizing: border-box;
  }
  .add-code-button {
    display: flex;
    padding: 5px;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    color: ${colors.black};
    border: 2px solid ${colors.black};
    border-radius: 8px;
    cursor: pointer;
  }
  .add-code-button--right {
    margin-left: auto;
  }
  .button-text {
    font-size: 14px;
    margin-bottom: 0;
  }
  .invite-codes-list {
    padding: 0 8px;
    margin-bottom: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .invite-codes-list :global(.MuiTableContainer-root) {
    flex: 1;
  }
  .invite-codes-pagination {
    display: flex;
    justify-content: flex-start;
    padding: 12px 8px;
    margin-top: auto;
  }
  .invite-codes-list :global(.invite-code-actions) {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .invite-codes-list :global(.edit-button) {
    cursor: pointer;
  }
  /* Match CircleUsersTable visual: grey header bg, AvenirNext font, compact cells */
  .invite-codes-list :global(.ant-table-thead > tr > th) {
    background: #f2f2f2;
    color: #000;
    font-family: AvenirNext, sans-serif;
    white-space: break-spaces;
    padding: 12px 4px !important;
  }
  .invite-codes-list :global(.ant-table-thead > tr > th:first-child) {
    border-top-left-radius: 8px;
  }
  .invite-codes-list :global(.ant-table-thead > tr > th:last-child) {
    border-top-right-radius: 8px;
  }
  .invite-codes-list :global(.ant-table-tbody > tr > td) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    font-family: AvenirNext, sans-serif;
    padding: 12px 4px;
  }
  .invite-codes-list :global(.ant-pagination.ant-table-pagination) {
    float: none;
    margin: 8px;
  }
`;
